<template>
  <!--开标情况和开标人员-->
  <div
    class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
  >
    <el-group-title
      class="ccui-group-wrapper d_jump box-title-margin"
      index="contract"
    >
      <template slot="groupTitle">
        <el-table :data="data" border>
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :show-overflow-tooltip="true"
            v-bind="item"
          ></el-table-column>
        </el-table>
      </template>
    </el-group-title>
  </div>
</template>

<script>
import { queryApi } from "@/app/bidOpening/api/index.js";
import reqUrl from "@/app/bidOpening/api/taskPreparationUrl.js";
export default {
  name: "openTenderDetailList",
  props: {},
  data() {
    return {
      data: [],
      columns: [
        {
          prop: "id",
          label: "序号",
          width: 50
        },
        {
          prop: "participantName",
          label: "姓名"
        },
        {
          prop: "workUnitName",
          label: "工作单位"
        },
        {
          prop: "tel",
          label: "办公电话"
        },
        {
          prop: "mobile",
          label: "手机号码",
          width: 110
        },
        {
          prop: "email",
          label: "邮箱"
        },
        {
          prop: "bidStatusStr",
          label: "是否开启"
        },
        {
          prop: "operateTime",
          label: "开启时间",
          width: 170
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.qryBidOpenUser();
    },
    //开标人员
    qryBidOpenUser() {
      let ids = "7";
      if (this.$router.history.current.query.evaPurStep === "801") {
        ids = "0701";
      } else if (this.$router.history.current.query.evaPurStep === "802") {
        ids = "0702";
      }
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        purStep: ids,
        // evaPurStep: this.$router.history.current.query.evaPurStep,
        isShowPageLoading: true
      };
      queryApi(reqUrl.qryBidOpenUserList, param).then(res => {
        if (res.data.code === "0") {
          res.data.data.forEach((item, index) => {
            item.id = index + 1;
          });
          this.$set(this, "data", res.data.data);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sub-contractor-detail-form-item {
  margin: 30px 20px;
}
.ccui-group-wrapper {
  /deep/ .el-table .el-table__body .cell {
    height: 36px;
    line-height: 36px;
  }
}
.box-title-margin {
  margin-top: 20px;
}
.btn-box {
  margin-bottom: 20px;
}
/deep/ .el-table__row td {
  border-right: 1px solid #edf2fc !important;
}

/deep/ .el-table--border td {
  border-right: 1px solid #edf2fc !important;
}

/deep/ .el-table__header th {
  border-right: 1px solid #edf2fc !important;
}
</style>
